module.exports = __webpack_public_path__ + "static/placeholder-timeline3-f8ff95aa60ca70ca40a3c0ef5290b3dc.svg";